const NoMatch = () => {
  return <div>La page n'éxiste pas</div>;
};

export default NoMatch;
